import React from 'react';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

interface MinimalLoadingProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  fullScreen?: boolean;
}

export const MinimalLoading: React.FC<MinimalLoadingProps> = ({
  className,
  size = 'md',
  message = 'Carregando...',
  fullScreen = false,
}) => {
  const iconSizes = {
    sm: 'w-5 h-5',
    md: 'w-7 h-7',
    lg: 'w-10 h-10',
  };

  const containerClass = fullScreen
    ? 'min-h-screen fixed inset-0 z-50 bg-background'
    : '';

  return (
    <div className={cn('flex flex-col items-center justify-center p-8', containerClass, className)}>
      <Loader2 className={cn('animate-spin text-muted-foreground/50', iconSizes[size])} />
      {message && (
        <p className="mt-3 text-xs text-muted-foreground/60">{message}</p>
      )}
    </div>
  );
};

export default MinimalLoading;
